var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51566 0.477531C6.31383 0.0960312 5.68616 0.0960312 5.48433 0.477531L0.234329 10.3942C0.187247 10.4831 0.163959 10.5827 0.166724 10.6832C0.16949 10.7838 0.198217 10.8819 0.250114 10.9681C0.302011 11.0543 0.375315 11.1256 0.462905 11.1751C0.550495 11.2246 0.649394 11.2506 0.749996 11.2505H11.25C11.3506 11.2507 11.4495 11.2249 11.5372 11.1755C11.6248 11.1261 11.6981 11.0548 11.75 10.9686C11.8019 10.8824 11.8305 10.7842 11.8332 10.6837C11.8358 10.5831 11.8124 10.4836 11.7651 10.3948L6.51566 0.477531ZM6.58333 9.50053H5.41666V8.33386H6.58333V9.50053ZM5.41666 7.1672V4.25053H6.58333L6.58391 7.1672H5.41666Z",
    fill: "#DC6700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/suspend.7ac32be78fe07c7226059a9e425741f0.svg";
export { ForwardRef as ReactComponent };